var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import classnames from 'classnames';
import { getArcProperties } from './utils';
import renderFilter from './_filter';
import RadialProgress from './RadialProgress';
import './ProgressInfinite.css';
const _b = (_a = RadialProgress.propTypes) !== null && _a !== void 0 ? _a : {},
  {
    children,
    diameter
  } = _b;
class ProgressInfinite extends Component {
  constructor() {
    super(...arguments);
    this.componentDidMount = renderFilter;
  }
  render() {
    const _a = this.props,
      {
        color,
        className
      } = _a,
      rest = __rest(_a, ["color", "className"]);
    const classes = classnames(className, 'ax-progress-infinite', `ax-progress-infinite--${color}`);
    const {
      diameter,
      innerRadius,
      strokeWidth,
      strokeDasharray,
      strokeDashoffset
    } = getArcProperties({
      percent: 75
    });
    return _jsx(RadialProgress, Object.assign({}, rest, {
      className: classes,
      diameter: diameter,
      children: _jsx("circle", {
        className: "ax-progress-infinite__arc",
        r: innerRadius,
        style: {
          stroke: `url(#ax-progress-infinite__filter--${color})`,
          strokeDasharray,
          strokeDashoffset,
          strokeWidth
        }
      })
    }));
  }
}
ProgressInfinite.defaultProps = {
  color: 'subtle',
  size: 'small'
};
export default ProgressInfinite;